<ng-container [formGroup]="envasesForm">
    <td [ngClass]="{'show-error': showError}">
        <input type="text" formControlName="id">
    </td>
    <td [ngClass]="{'show-error': showError}">
        <app-filterable-list [itemsList]="allEnvases" [selectedItem]="envasesForm.get('envase')" [disabled]="disabledEnvases" [placeHolder]="false"></app-filterable-list>
    </td>
    <td [ngClass]="{'show-error': showError}">
        <input type="number" formControlName="peso">
    </td>
    <td [ngClass]="{'show-error': showError}">
        <input type="number" min="1" value="1" formControlName="cantidad">
    </td>
    <td class="multi-actions">
        <ng-container *ngIf="editable">
            <i class="far fa-save" title="{{'titles.guardar' | translate}}" (click)="save()"></i>
            <i class="fas fa-times" title="{{'global.cancelar' | translate}}" (click)="cancel()"></i>
        </ng-container>
        <ng-container *ngIf="!editable">
            <i class="far fa-trash-alt" title="{{'titles.eliminar' | translate}}" (click)="remove()"></i>
        </ng-container>
    </td>
</ng-container>
<app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
